"use strict";

exports.__esModule = true;
exports.colnumProps = colnumProps;
exports.cols = exports.breakpoints = void 0;

/*
shared utils for Grid component
*/
// possible breakpoints
var breakpoints = ['xs', 'sm', 'md', 'lg']; // column widths

exports.breakpoints = breakpoints;
var cols = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]; // custom prop for column numbers

exports.cols = cols;

function colnumProps(props, propName, componentName) {
  /* eslint-disable react/destructuring-assignment */
  if (props[propName] > 12) {
    /* eslint-disable prefer-template */
    return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Must be equal to or less than 12.');
  }

  return null;
}